// extracted by mini-css-extract-plugin
export default {"wrapper":"GeneralButton_wrapper__fzSAF","container":"GeneralButton_container__eo2nn","generalButton":"GeneralButton_generalButton__jNzrV"};